import api from '../api';

export const $to = async(text,locale) => {
    let response = await api.translate(text,locale)
    return response.data;
}

export const $t = (text,locale,obj) => {
    let result = "";//text;
    for(let i=0;i<obj.length;i++){
        if(obj[i]['key'] == text){
            if(obj[i]['translations']!=null){
                for(let j=0;j<obj[i]['translations'].length;j++){
                    if(obj[i]['translations'][j]['locale'] == locale){
                        result = obj[i]['translations'][j]['value'];
                    }
                }
            }
        }
    }
    return result;
}


// WEBPACK FOOTER //
// ./utils/translate.js